var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{ref:"pieloader",attrs:{"hidden":_vm.pieHidden}}),_c('div',{ref:"barloader",attrs:{"hidden":_vm.barHidden}})])}
var staticRenderFns = []

export { render, staticRenderFns }